import {
  SITE_URL,
  SITE_NAME,
  DEFAULT_TITLE,
  DEFAULT_DESCRIPTION,
} from "./siteConfig";

/**
 * Per-path SEO for SPA navigation (search engines that run JS see updates).
 * Order: more specific paths first.
 */
export function getSeoForPath(pathname) {
  const path = pathname.endsWith("/") && pathname.length > 1
    ? pathname.slice(0, -1)
    : pathname;

  const base = {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    robots: "index, follow",
  };

  const withCanonical = (slug, overrides) => ({
    ...base,
    ...overrides,
    canonicalPath: slug,
  });

  if (path === "/" || path === "") {
    return withCanonical("/", {
      title: DEFAULT_TITLE,
      description:
        "Медицински център Деница в Монтана предлага прегледи, диагностика, специалисти и лабораторни изследвания.",
    });
  }

  if (path === "/lichni-lekari-montana") {
    return withCanonical("/lichni-lekari-montana", {
      title: `Лични лекари в Монтана | ${SITE_NAME}`,
      description:
        "Лични лекари и профилактика в Монтана — Медицински център Деница.",
    });
  }

  if (path.startsWith("/lichen-lekar-montana/")) {
    return withCanonical(path, {
      title: `Лекар в Монтана | ${SITE_NAME}`,
      description:
        "Профил на лекар и записване на преглед в Медицински център Деница, Монтана.",
    });
  }

  if (path === "/laboratoriq-montana") {
    return withCanonical("/laboratoriq-montana", {
      title: `Клинична лаборатория Монтана | ${SITE_NAME}`,
      description:
        "Лабораторни изследвания и диагностика в Монтана — Деница и Диамед-М.",
    });
  }

  if (path === "/specialnosti") {
    return withCanonical("/specialnosti", {
      title: `Медицински специалности Монтана | ${SITE_NAME}`,
      description:
        "Специалисти и медицински специалности в Монтана — прегледи в МЦ Деница.",
    });
  }

  if (path === "/spetsialisti-montana") {
    return withCanonical("/spetsialisti-montana", {
      title: `Лекари специалисти в Монтана | ${SITE_NAME}`,
      description:
        "Екипът на МЦ Деница — лекари специалисти по всички медицински специалности в Монтана.",
    });
  }

  if (path === "/specialnosti-lkk") {
    return withCanonical("/specialnosti-lkk", {
      title: `Лекарски консултативни комисии (ЛКК) | ${SITE_NAME}`,
      description:
        "Лекарски консултативни комисии в Монтана — Медицински център Деница.",
    });
  }

  if (path.startsWith("/gost-lekar/")) {
    return withCanonical(path, {
      title: `Гостуващ лекар | ${SITE_NAME}`,
      description:
        "Гостуващ специалист и прегледи в Медицински център Деница, Монтана.",
    });
  }

  if (path.startsWith("/meditsintska-specialnost-montana/")) {
    return withCanonical(path, {
      title: `Медицинска специалност Монтана | ${SITE_NAME}`,
      description:
        "Информация за медицинска специалност и прегледи в МЦ Деница, Монтана.",
    });
  }

  if (path.startsWith("/dopulnitelni-meditsinski-uslugi/")) {
    return withCanonical(path, {
      title: `Допълнителни медицински услуги | ${SITE_NAME}`,
      description:
        "Допълнителни медицински услуги в Монтана — Медицински център Деница.",
    });
  }

  if (path === "/contact") {
    return withCanonical("/contact", {
      title: `Контакти | ${SITE_NAME}`,
      description:
        "Адрес, телефони и контакти на Медицински център Деница в Монтана.",
    });
  }

  if (path === "/results") {
    return withCanonical("/results", {
      title: `Лабораторни резултати | ${SITE_NAME}`,
      description:
        "Проверка на лабораторни резултати — Медицински център Деница, Монтана.",
    });
  }

  if (path === "/404") {
    return withCanonical("/404", {
      title: `Страницата не е намерена | ${SITE_NAME}`,
      description: DEFAULT_DESCRIPTION,
      robots: "noindex, follow",
    });
  }

  /* Unknown URL → 404 view: avoid indexing soft-404 content */
  return withCanonical(path, {
    title: `Страницата не е намерена | ${SITE_NAME}`,
    description: DEFAULT_DESCRIPTION,
    robots: "noindex, follow",
  });
}

export function absoluteUrl(canonicalPath) {
  if (!canonicalPath || canonicalPath === "/") {
    return `${SITE_URL}/`;
  }
  return `${SITE_URL}${canonicalPath.startsWith("/") ? "" : "/"}${canonicalPath}`;
}
